import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canBeClosed)?_c(VIcon,_vm._b({staticClass:"cursor-pointer",attrs:{"color":_vm.color},on:{"click":function($event){return _vm.closeWindow()}}},'v-icon',_vm.$attrs,false),[_vm._v("mdi-close")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }